module.exports = FormData;


/*****************
 ** WEBPACK FOOTER
 ** ./~/superagent/~/form-data/lib/browser.js
 ** module id = 1255
 ** module chunks = 0
 **/